/**
 * Takes a timestamp and formats it according to a specific date format. There is no single
 * locale that fulfills CW's requirements for date formatting.
 *
 * @param {Integer} timestamp      The UNIX-compliant timestamp, either in seconds or milliseconds.
 * @param {Boolean} inMilliseconds Whether or not the given timestamp is in seconds or milliseconds.
 * @returns {String}
 */
export const formattedDate = (timestamp, inMilliseconds = false) => {
  const datetime = new Date(timestamp * (inMilliseconds ? 1 : 1000));

  return `${datetime.toLocaleString('en-GB', { day: 'numeric', timeZone: 'Europe/London' })}
    ${datetime.toLocaleString('en-GB', { month: 'long', timeZone: 'Europe/London' })}
    ${datetime.toLocaleString('en-GB', { year: 'numeric', timeZone: 'Europe/London' })}`;
};

/**
 * Formats a timestamp using one of the supported formats (Europe/London time zone):
 * - "yyyy"         → 2018
 * - "MMMM yyyy"    → January 2018
 * - "dd MMMM yyyy" → 05 January 2018
 *
 * @param {Integer} timestamp The UNIX-compliant timestamp in seconds.
 * @param {String} pattern    One of the supported formats.
 * @returns {String|null}     The formatted date or null if the format is empty/unsupported or
 *                            the timestamp is not a valid date.
 */
export const formattedDateByFormat = (timestamp, pattern) => {
  const datetime = new Date(timestamp * 1000);
  const options = {
    yyyy: { year: 'numeric' },
    'MMMM yyyy': { month: 'long', year: 'numeric' },
    'dd MMMM yyyy': { day: '2-digit', month: 'long', year: 'numeric' },
  }[typeof pattern === 'string' ? pattern.trim() : ''];

  if (!options || Number.isNaN(datetime.getTime())) {
    return null;
  }

  return datetime.toLocaleString('en-GB', { ...options, timeZone: 'Europe/London' });
};
